"use strict";
import AutoComplete from "src/decidim/autocomplete";
const apiRequest = (query) => {
  return new Promise((resolve) => {
    fetch(window.Decidim.config.get("api_path"), {
      method: "post",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ query: `{ ${query} }` })
    }).then((response) => response.json()).then((queryResponse) => {
      resolve(queryResponse.data);
    });
  });
};
const resolveParticipatorySpaceTypes = () => {
  const schemaQuery = `
    __schema {
      queryType {
        fields {
          name
          type {
            kind
            ofType {
              ofType {
                interfaces {
                  name
                }
                kind
              }
            }
          }
        }
      }
    }
  `;
  const isParticipatorySpaceField = (field) => {
    if (field.type.kind !== "LIST") {
      return false;
    }
    if (!field.type.ofType || !field.type.ofType.ofType || !field.type.ofType.ofType.interfaces) {
      return false;
    }
    if (!field.type.ofType.ofType.interfaces.some((interf) => interf.name === "ParticipatorySpaceInterface")) {
      return false;
    }
    return true;
  };
  return new Promise((resolve) => {
    apiRequest(schemaQuery).then((result) => {
      const types = [];
      for (const field of result.__schema.queryType.fields) {
        if (isParticipatorySpaceField(field)) {
          types.push(field.name);
        }
      }
      resolve(types);
    });
  });
};
const getParticipatorySpaces = () => {
  const currentLocale = document.documentElement.lang;
  const spaceQuery = `
    id
    title { translation(locale: "${currentLocale}") }
    manifest {
      name
      humanName {
        plural { translation(locale: "${currentLocale}") }
      }
    }
  `;
  return new Promise((resolve) => {
    resolveParticipatorySpaceTypes().then((types) => {
      const spaceQueries = types.map((type) => `${type} { ${spaceQuery} }`);
      apiRequest(spaceQueries.join("\n\n")).then((spacesData) => {
        const spacesList = [];
        for (const type of types) {
          if (spacesData[type].length > 0) {
            spacesList.push({
              type: spacesData[type][0].manifest.name,
              name: spacesData[type][0].manifest.humanName.plural.translation,
              list: spacesData[type].map((space) => {
                return {
                  id: parseInt(space.id, 10),
                  title: space.title.translation
                };
              })
            });
          }
        }
        resolve(spacesList);
      });
    });
  });
};
const createAutocomplete = (searchInput, spaces, inputIndex) => {
  const dataSource = (query, callback) => {
    const regexp = new RegExp(query, "i");
    const results = [];
    for (const currentSpace of spaces) {
      for (const space of currentSpace.list) {
        if (regexp.test(space.title)) {
          results.push({
            value: `${currentSpace.type}(${space.id})`,
            label: `${currentSpace.name} - ${space.title}`
          });
        }
      }
    }
    callback(results);
  };
  const resolveSelectedValue = (originalValue) => {
    if (!originalValue) {
      return null;
    }
    const valueMatches = originalValue.match(/([a-z_]+)\(([0-9]+)\)/);
    if (!valueMatches) {
      return null;
    }
    const valueType = valueMatches[1];
    const valueId = parseInt(valueMatches[2], 10);
    for (const currentSpace of spaces) {
      if (currentSpace.type === valueType) {
        const space = currentSpace.list.find((item) => item.id === valueId);
        if (space) {
          return {
            value: `${currentSpace.type}(${space.id})`,
            label: `${currentSpace.name} - ${space.title}`
          };
        }
      }
    }
    return null;
  };
  let selected = null;
  const selectedValue = resolveSelectedValue(searchInput.dataset.selected);
  if (selectedValue) {
    selected = { key: "label", value: selectedValue };
  }
  const ac = new AutoComplete(searchInput, {
    name: searchInput.getAttribute("name"),
    placeholder: searchInput.getAttribute("placeholder"),
    mode: "sticky",
    threshold: 3,
    dataMatchKeys: ["label"],
    selected,
    dataSource
  });
  searchInput.name = `participatory_space_search_${inputIndex}`;
  return ac;
};
document.addEventListener("DOMContentLoaded", () => {
  const searchElements = document.querySelectorAll("input.participatory-space-search");
  if (searchElements.length < 1) {
    return;
  }
  getParticipatorySpaces().then((spaces) => {
    let index = 0;
    for (const searchInput of searchElements) {
      createAutocomplete(searchInput, spaces, index);
      index += 1;
    }
  });
});
